import { notification } from "antd";


import { ISuccessNotification } from "common/types";
import { getAppFeedbackApi } from "../app-feedback";



const successNotification = ({
    title,
    description,
    duration = 4,
}: ISuccessNotification): void =>
{

    const notificationApi = getAppFeedbackApi()?.notification || notification;

    notificationApi.success({
        message: title,
        description: description,
        duration: duration,
        className: "success-notification",
        //icon: <Icons.ActionStatus type="success"/>,
        // closeIcon: <Icons.Close />,
    });

};

export default successNotification;
